<template>
    <Navbar :title="title" />
    <Sidebar />
    <MobileNavbar />
</template>

<script>
import MobileNavbar from './MobileNavbar.vue'
import Navbar from './Navbar.vue'
import Sidebar from './Sidebar.vue'

export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    components: {
        Navbar,
        Sidebar,
        MobileNavbar
    }
}

</script>